// extracted by mini-css-extract-plugin
export default {"action":"action--si2dEZy4qK"};